module.exports = __webpack_public_path__ + "img/stand_height.a881e432.png";